import { IAddStaffManagement, IUpdateStaffManagement } from "../../models/forms/IAddStaff";

export const AddStaffState: IUpdateStaffManagement = {
    Id: 0,
    StoreId: -1,
    StaffName: "",
    TelephoneNumber: "",
    Email: "",
    PostCode: "",
    Address: "",
    AccountStatus: "Valid",
    NumberOfAvailability: 1,
    NominationFee: "",
    Image: "",
    Password: "",
    ConfirmPassword: "",
    PrefectureName: "",
    OrderId: "",
    Gender: "0",
    Expertise: "",
    Introduction: "",
    OrderIdPersist: "",
    TotalCount: -1,
    EmailUserType: 0,
    IsOtherStaffEmail: false,
    ShowOnReservationSite: true,
};